
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
function Alanditomumbaicabsservice() {



    const cardData =
    {
        keyword: ' Alandi to Mumbai Cabs Service',
        heading: 'Prince Cabs: Alandi to Mumbai Cabs Service',
        headingDescription: 'Prince Cabs provides reliable Alandi to Mumbai Cabs Service, perfect for airport transfers, family travel, business trips, and outstation journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe, comfortable, and convenient ride from Alandi to Mumbai via the expressway. With professional chauffeurs, punctual pickups, and transparent pricing, we make your travel smooth and hassle-free. Choose Prince Cabs’ trusted cab service from Alandi to Mumbai for comfort, affordability, and reliability.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic monument overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. Today, it is a bustling hub with tourists, photographers, and ferry rides to Elephanta Caves. The monument looks magical at sunset and when illuminated at night. It remains the proud symbol of South Mumbai. Gateway of India is the city’s historic and cultural centerpiece."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also called the Queen’s Necklace, is a 3.6 km long seafront promenade. Its curved road lit up at night resembles a glittering necklace. Locals and tourists love it for evening walks, jogging, and sea views. During monsoon, crashing waves create dramatic scenes. Sunsets here are breathtaking and romantic. Marine Drive is Mumbai’s favorite leisure hub."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage Site and Mumbai’s busiest railway station. Built in 1887, it features Gothic Revival architecture with domes, spires, and stained-glass windows. The structure glows beautifully when lit at night. It serves millions of commuters daily, blending history with modern life. Tourists admire its grand design while experiencing Mumbai’s lifeline—the local trains. CST is a masterpiece of heritage architecture."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are ancient UNESCO-listed rock-cut temples. Dating back to the 5th–6th centuries, the caves are dedicated to Lord Shiva. The Trimurti sculpture is the highlight, showcasing remarkable craftsmanship. Accessible by ferry from Gateway of India, the island offers peace and greenery. It is a perfect escape from the city rush. Elephanta Caves reflect India’s cultural and artistic legacy."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most popular beach, famous for street food and Bollywood connections. Visitors enjoy pav bhaji, bhel puri, and ice gola while walking along the sand. Families gather here in the evenings for leisure and sea breezes. The area is surrounded by luxury hotels and celebrity residences. Sunsets at Juhu are magical. It is the best place to experience Mumbai’s coastal charm."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is Mumbai’s most revered shrine dedicated to Lord Ganesha. Built in 1801, it draws thousands of devotees, including celebrities and politicians. The golden dome and intricately carved doors add grandeur. Tuesdays witness the largest gatherings. Devotees believe prayers here are always fulfilled. Siddhivinayak is the spiritual heart of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge and a marvel of modern engineering. It connects South Mumbai to the western suburbs. Driving across the bridge offers stunning views of the Arabian Sea. At night, its illuminated structure looks spectacular. It has reduced travel time significantly for daily commuters. The Sea Link is a modern icon of Mumbai’s progress."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet in the Arabian Sea. Dedicated to Sufi saint Pir Haji Ali Shah Bukhari, it is visited by devotees of all faiths. The Indo-Islamic architecture stands beautifully against the sea backdrop. Accessible via a narrow causeway during low tide, it creates a unique experience. The shrine offers peace and blessings. Haji Ali is Mumbai’s landmark of spirituality and unity."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s most famous shopping street, buzzing with shops and street vendors. It offers everything from handicrafts and clothes to jewelry and antiques. Iconic cafés like Leopold Café and Café Mondegar add to its charm. Bargaining with vendors is part of the fun. The area is always crowded with locals and tourists. Colaba reflects Mumbai’s vibrant and cosmopolitan spirit."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for Ganesh Visarjan celebrations. It is a hotspot for local snacks like pav bhaji, kulfi, and bhel puri. Families and children enjoy the festive vibe in the evenings. Festivals and fairs make it even more colorful. The beach also offers views of Marine Drive. Chowpatty blends leisure, tradition, and culture in one place."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City is the beating heart of Bollywood, spread across 500 acres in Goregaon. It has multiple studios, artificial sets, and shooting zones. Guided tours let visitors witness behind-the-scenes of movie-making. Many films and TV shows are shot here daily. It is one of the largest film production complexes in the world. Film City defines Mumbai’s role as India’s entertainment capital."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a massive green sanctuary within Mumbai, spread over 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park, the Kanheri Caves display Buddhist monasteries and stupas dating back to the 1st century BC. Visitors enjoy safaris, toy train rides, and trekking trails. It is rare to find such nature inside a metro city. The park is a blend of history, adventure, and wildlife."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by lush greenery and modern skyscrapers. It is popular among birdwatchers, with sightings of kingfishers, herons, and migratory birds. Locals enjoy walking and jogging along its promenade. During monsoon, the lake looks especially scenic with misty views. Families visit for picnics and photography. Powai Lake offers calm in the heart of Mumbai."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda near Gorai is one of the largest meditation domes in the world. Built in Burmese style, it houses sacred relics of Buddha. The golden dome can accommodate thousands of meditators. Visitors attend sessions and admire the stunning design. Its seaside location adds serenity and peace. The pagoda symbolizes spirituality and mindfulness."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is a hub for astronomy and science enthusiasts. It hosts sky shows that explain stars, planets, and galaxies in an engaging way. The adjoining Science Centre has interactive exhibits on technology and space. Students and families love its educational yet fun atmosphere. Special events during eclipses and celestial activities attract crowds. It inspires curiosity and knowledge about space."
  }
],

"services": [
  {
    "name": "Alandi to Mumbai Taxi",
    "description": "Book trusted taxi services from Alandi to Mumbai with comfortable seating, clean vehicles, and professional drivers who prioritize punctuality and safety. Whether you're traveling for business, leisure, or family visits, this service ensures a hassle-free journey through well-planned routes and tailored departure times."
  },
  {
    "name": "Alandi to Mumbai Cab Booking",
    "description": "Easily book a cab from Alandi to Mumbai via our streamlined booking platform. Choose from a fleet of sedans, SUVs, and MPVs with flexible schedules, transparent pricing, and dependable service ideal for both planned and last-minute travel needs."
  },
  {
    "name": "Alandi to Mumbai Innova Cab",
    "description": "Travel in comfort and style with our Innova cab service from Alandi to Mumbai. This well-appointed MPV offers spacious interiors, ample storage space, and a smooth ride—perfect for families, small groups, or anyone looking to travel relaxed and secure over the longer distance."
  },
  {
    "name": "Alandi to Mumbai Airport Drop",
    "description": "Ensure timely airport transfers from Alandi to Mumbai with our dedicated drop service. Benefit from reliable pickups, driver assistance with luggage, real-time tracking, and a calm journey to the airport—no stress, just timely arrivals and smooth transitions to your flight."
  },
  {
    "name": "Alandi to Mumbai Dzire Cab",
    "description": "Book a budget-friendly Dzire cab from Alandi to Mumbai—a practical and reliable option for solo travelers or small families. This vehicle combines efficient fuel use, clean interiors, AC comfort, and professional service with minimal fuss and clear upfront costs."
  },
  {
    "name": "Alandi to Mumbai Ertiga Rental",
    "description": "Opt for our Ertiga rental service from Alandi to Mumbai for spacious comfort and added flexibility. This 7-seater is convenient for group trips or family travel, offering ample legroom, luggage space, and reliable driver assistance for an enjoyable long-distance ride."
  },
  {
    "name": "Alandi to Mumbai One Way Taxi",
    "description": "Book a one-way taxi from Alandi to Mumbai at competitive rates—ideal for travelers planning separate return arrangements. Enjoy prompt pickups, courteous drivers, and straightforward billing without return trip commitments."
  },
  {
    "name": "Alandi to Mumbai Sedan Booking",
    "description": "Reserve a comfortable sedan from Alandi to Mumbai for a serene and efficient journey. Choose from popular models like Dzire or Etios, each offering fuel efficiency, clean presentation, and a comfortable local or intercity commute at an affordable price."
  },
  {
    "name": "Alandi to Mumbai Round Trip Cab",
    "description": "Plan your round-trip travel between Alandi and Mumbai with flexibility. Our round-trip cabs come with coordinated pickup and return timing, allowing enough waiting time at your destination before heading back—ideal for quick visits, business travel, or overnight stays."
  },
  {
    "name": "Affordable Cabs Alandi to Mumbai",
    "description": "Looking for value without sacrificing reliability? Our affordable cabs from Alandi to Mumbai deliver quality service, safe vehicles, and courteous drivers—all at budget-conscious rates with transparent billing and consistent performance."
  },
  {
    "name": "Crysta Cab Alandi to Mumbai",
    "description": "Upgrade your journey with Innova Crysta cabs from Alandi to Mumbai—offering a premium travel experience with comfortable interiors, advanced suspension, and enough room to stretch out. Ideal for VIP travel, business groups, or anyone wanting a little extra luxury."
  },
  {
    "name": "Alandi to Mumbai Tour Package",
    "description": "Explore Mumbai with ease using our tailored tour cab packages starting from Alandi. Our service includes select sightseeing stops along the route, flexible itineraries, and relaxed travel—great for tourists or visiting relatives looking to combine comfort with exploration."
  },
  {
    "name": "Family Cab Alandi to Mumbai",
    "description": "Travel comfortably as a family from Alandi to Mumbai with our family-oriented cab service. Spacious vehicles, safety features like child seat options, and driven by courteous professionals make it easy for all ages to travel safely together."
  },
  {
    "name": "Alandi to Mumbai Drop Charges",
    "description": "Check clear and transparent drop charges for cab services between Alandi and Mumbai. No hidden fees—just straightforward fare estimates based on your chosen vehicle type and journey distance for stress-free travel planning."
  },
  {
    "name": "Alandi to Mumbai SUV Service",
    "description": "Opt for a robust SUV cab service from Alandi to Mumbai, perfect for travelers with extra luggage, or groups seeking a spacious and powerful ride. SUVs offer enhanced comfort and stability on both highway and urban roads."
  }
],
"tableData": [
  ["Alandi to Mumbai Taxi", "Alandi to Mumbai Cab Booking"],
  ["Alandi to Mumbai Innova Cab", "Alandi to Mumbai Airport Drop"],
  ["Alandi to Mumbai Dzire Cab", "Alandi to Mumbai Ertiga Rental"],
  ["Alandi to Mumbai One Way Taxi", "Alandi to Mumbai Sedan Booking"],
  ["Alandi to Mumbai Round Trip Cab", "Affordable Cabs Alandi to Mumbai"],
  ["Crysta Cab Alandi to Mumbai", "Alandi to Mumbai Tour Package"],
  ["Family Cab Alandi to Mumbai", "Alandi to Mumbai Drop Charges"],
  ["Alandi to Mumbai SUV Service"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Cab Service from Alandi to Mumbai",
    "WhyChoosedescription": "Prince Cabs offers dependable and comfortable cab services from Alandi to Mumbai, perfect for business travelers, tourists, and families. Covering approximately 150 kilometers, our service ensures timely pickups, smooth rides, and hassle-free travel, allowing you to reach your destination in Mumbai relaxed and on time."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Our fleet features a range of vehicles including sedans and SUVs like Swift Dzire, Ertiga, and Innova, all well-maintained and equipped with spacious seating, ample luggage space, and air conditioning to ensure maximum comfort during your journey from Alandi to Mumbai."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Route Expertise",
    "WhyChoosedescription": "Our professional drivers are familiar with the Alandi to Mumbai route, ensuring safe driving, efficient navigation, and timely breaks. Their expertise guarantees a smooth and pleasant journey."
  },
  {
    "WhyChooseheading": "Flexible Booking Options to Suit Your Travel Needs",
    "WhyChoosedescription": "Prince Cabs offers flexible packages including one-way trips, round trips, and multi-day rentals. You can easily book via phone, WhatsApp, or online, with instant confirmation and flexible cancellation policies."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing is clear and competitive, covering fuel, tolls, driver allowances, and taxes. We accept multiple secure payment methods including UPI, credit/debit cards, net banking, and cash for your convenience."
  },
  {
    "WhyChooseheading": "Sanitized and Safe Vehicles for Passenger Protection",
    "WhyChoosedescription": "Each vehicle is thoroughly cleaned and sanitized before every trip. Regular maintenance ensures mechanical reliability, and safety features such as seat belts and airbags provide passenger protection throughout the journey."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Smooth Travel Experience",
    "WhyChoosedescription": "Our dedicated customer care team is available 24/7 to assist with bookings, itinerary changes, and any travel-related queries, ensuring a hassle-free and smooth cab experience from Alandi to Mumbai."
  }
]























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide cab services from Alandi to Mumbai?',
        answer: 'Yes, Prince Cabs offers reliable and comfortable cab services from Alandi to Mumbai for business, leisure, and family travel.',
    },
    {
        question: 'What types of vehicles are available for Alandi to Mumbai trips?',
        answer: 'We provide a variety of vehicles including Swift Dzire, Ertiga, Innova, and Tempo Traveller to suit solo travelers, families, and groups.',
    },
    {
        question: 'How long does the journey from Alandi to Mumbai take by cab?',
        answer: 'The journey typically takes around 5 to 6 hours depending on traffic and road conditions.',
    },
    {
        question: 'Can I book a round-trip cab from Alandi to Mumbai?',
        answer: 'Yes, Prince Cabs offers flexible one-way and round-trip packages tailored to your travel needs.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained for long-distance travel?',
        answer: 'Absolutely! All vehicles are regularly cleaned, sanitized, and serviced to ensure your safety and comfort throughout the trip.',
    },
    {
        question: 'What are the approximate fares for Alandi to Mumbai cab service?',
        answer: 'Fares vary based on vehicle type, distance, and duration. Please contact Prince Cabs for a personalized and competitive quote.',
    },
    {
        question: 'How do I book a cab from Alandi to Mumbai?',
        answer: 'You can easily book through our website or by calling our customer support team with your travel details for quick confirmation.',
    },
];

const testimonials = [
    {
        name: "Mr. Rahul Shinde",
        position: "Frequent Traveler",
        text: "Prince Cabs provided a smooth and comfortable ride from Alandi to Mumbai. The driver was professional and punctual.",
        image: "/img/testimonial/testimonial-thumb-alandi-mumbai-1.png",
    },
    {
        name: "Ms. Sneha Kulkarni",
        position: "Business Traveler",
        text: "Booking a cab from Alandi to Mumbai with Prince Cabs was easy and hassle-free. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-alandi-mumbai-2.png",
    },
];


















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Alandi to Mumbai Cabs Service",
  "description": "Affordable and reliable cab services from Alandi to Mumbai including Innova, Dzire, Ertiga, Sedan, SUV, airport drop, one way, round trip, and family tour packages.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Alandi",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Alandi to Mumbai Taxi",
    "Alandi to Mumbai Cab Booking",
    "Alandi to Mumbai Innova Cab",
    "Alandi to Mumbai Airport Drop",
    "Alandi to Mumbai Dzire Cab",
    "Alandi to Mumbai Ertiga Rental",
    "Alandi to Mumbai One Way Taxi",
    "Alandi to Mumbai Sedan Booking",
    "Alandi to Mumbai Round Trip Cab",
    "Affordable Cabs Alandi to Mumbai",
    "Crysta Cab Alandi to Mumbai",
    "Alandi to Mumbai Tour Package",
    "Family Cab Alandi to Mumbai",
    "Alandi to Mumbai Drop Charges",
    "Alandi to Mumbai SUV Service"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Alandi"
  }
};




    return (
        <div>
<Helmet>
  <title>Alandi to Mumbai Cabs Service | Innova, Dzire, Ertiga Taxi</title>
  <meta
    name="description"
    content="Affordable and reliable cab services from Alandi to Mumbai including Innova, Dzire, Ertiga, Sedan, SUV, airport drop, one way, round trip, and family tour packages."
  />
  <meta
    name="keywords"
    content="Alandi to Mumbai Taxi, Alandi to Mumbai Cab Booking, Alandi to Mumbai Innova Cab, Alandi to Mumbai Airport Drop, Alandi to Mumbai Dzire Cab, Alandi to Mumbai Ertiga Rental, Alandi to Mumbai One Way Taxi, Alandi to Mumbai Sedan Booking, Alandi to Mumbai Round Trip Cab, Affordable Cabs Alandi to Mumbai, Crysta Cab Alandi to Mumbai, Alandi to Mumbai Tour Package, Family Cab Alandi to Mumbai, Alandi to Mumbai Drop Charges, Alandi to Mumbai SUV Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/78.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                          
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                             {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Alanditomumbaicabsservice ;